import RecaptchaTerms from '../src/RecaptchaTerms';
export default RecaptchaTerms;
